import React, { useEffect, useState } from "react";
import { invoiceApi, apiError } from "../../api/lab";
import { useApp } from "../../AppProvider";
import { Modal, Button, Field } from "../../Components/UI/ui";
import PatientPicker from "../Appointments/PatientPicker";
import SkuLines from "../Appointments/SkuLines";

// POST /labInvoices — a sale with no booking behind it
const WalkInInvoice = ({ open, onClose, onSaved }) => {
  const { skus, loadSkus } = useApp();
  const [patient, setPatient] = useState(null);
  const [lines, setLines] = useState([]);
  const [dueDate, setDueDate] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!open) return;
    loadSkus();
    setPatient(null); setLines([]); setDueDate(""); setNotes(""); setErr(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const submit = async () => {
    setErr(null);
    if (!patient?._id) return setErr("Select or create a patient");
    if (lines.length === 0) return setErr("Add at least one item");
    setSaving(true);
    try {
      const inv = await invoiceApi.create({
        patientId: patient._id,
        expenseTable: lines.map((l) => ({ labSkuId: l.labSkuId, quantity: l.qty, discount: l.discount })),
        dueDate: dueDate ? new Date(dueDate).toISOString() : undefined,
        notes: notes.trim(),
      });
      onSaved?.(inv);
      onClose();
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="lg"
      title="Walk-in invoice"
      footer={
        <>
          {err && <span className="lab-danger-text" style={{ marginRight: "auto" }}>{err}</span>}
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" loading={saving} onClick={submit}>Create invoice</Button>
        </>
      }
    >
      <div className="lab-section"><h4>Patient</h4><PatientPicker value={patient} onChange={setPatient} /></div>
      <div className="lab-section"><h4>Items</h4><SkuLines skus={skus} lines={lines} onChange={setLines} qtyLabel="Qty" /></div>
      <div className="lab-grid cols-2">
        <Field label="Due date (optional)"><input type="date" className="lab-input" value={dueDate} onChange={(e) => setDueDate(e.target.value)} /></Field>
        <Field label="Notes"><input className="lab-input" value={notes} onChange={(e) => setNotes(e.target.value)} /></Field>
      </div>
    </Modal>
  );
};

export default WalkInInvoice;
